export class CloseRecruitmentDemandDTO {
  constructor({ demandId, comment } = {}) {
    this.demandId = demandId;
    this.comment = comment;
  }

  prepareCloseRecruitmentDemandData() {
    return {
      demandId: this.demandId,
      comment: this.comment,
    };
  }
}
